var _rect, _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBearerOnlineRider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 42,
    viewBox: "0 0 28 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7719,
    y: 17.193,
    width: 1.96491,
    height: 22.5965,
    rx: 0.982456,
    fill: "#FF8A29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#FF8A29",
    stroke: "#DB7723",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21052 20.8968C8.41228 20.8968 7.73377 20.6175 7.175 20.0587C6.61623 19.4999 6.33684 18.8214 6.33684 18.0232H4.42105V15.1495C4.42105 14.0958 4.79623 13.1938 5.54658 12.4434C6.29693 11.6931 7.19895 11.3179 8.25263 11.3179H12.0842V16.1074H15.4368L18.7895 11.9405V9.4021H15.9158V7.48631H18.7895C19.3163 7.48631 19.7673 7.6739 20.1425 8.04908C20.5177 8.42425 20.7053 8.87526 20.7053 9.4021V12.611L16.3947 18.0232H12.0842C12.0842 18.8214 11.8048 19.4999 11.2461 20.0587C10.6873 20.6175 10.0088 20.8968 9.21052 20.8968ZM9.21052 18.981C9.48193 18.981 9.70943 18.8893 9.89302 18.7057C10.0766 18.5221 10.1684 18.2946 10.1684 18.0232H8.25263C8.25263 18.2946 8.34443 18.5221 8.52802 18.7057C8.71162 18.8893 8.93912 18.981 9.21052 18.981ZM7.29474 10.36V8.44421H12.0842V10.36H7.29474ZM20.7053 20.8968C19.907 20.8968 19.2285 20.6175 18.6697 20.0587C18.111 19.4999 17.8316 18.8214 17.8316 18.0232C17.8316 17.2249 18.111 16.5464 18.6697 15.9876C19.2285 15.4289 19.907 15.1495 20.7053 15.1495C21.5035 15.1495 22.182 15.4289 22.7408 15.9876C23.2996 16.5464 23.5789 17.2249 23.5789 18.0232C23.5789 18.8214 23.2996 19.4999 22.7408 20.0587C22.182 20.6175 21.5035 20.8968 20.7053 20.8968ZM20.7053 18.981C20.9767 18.981 21.2042 18.8893 21.3878 18.7057C21.5714 18.5221 21.6632 18.2946 21.6632 18.0232C21.6632 17.7518 21.5714 17.5243 21.3878 17.3407C21.2042 17.1571 20.9767 17.0653 20.7053 17.0653C20.4339 17.0653 20.2064 17.1571 20.0228 17.3407C19.8392 17.5243 19.7474 17.7518 19.7474 18.0232C19.7474 18.2946 19.8392 18.5221 20.0228 18.7057C20.2064 18.8893 20.4339 18.981 20.7053 18.981ZM6.33684 16.1074H10.1684V13.2337H8.25263C7.72579 13.2337 7.27478 13.4213 6.8996 13.7964C6.52443 14.1716 6.33684 14.6226 6.33684 15.1495V16.1074Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_49"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1579,
    height: 19.1579,
    fill: "white",
    transform: "translate(4.42105 4.42105)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearerOnlineRider);
export default __webpack_public_path__ + "static/media/bearer-online-rider.82cfa1a1548fe0b27d913c6d605cc30f.svg";
export { ForwardRef as ReactComponent };